export default "__VITE_ASSET__CnXB9_50__"